import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { UncontrolledTooltip, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import i18n from "../../i18n";
import { ServiceStatus, Permissions, ServiceScheduledType } from "../../constants/enums";
import NotesServiceModal from "./NotesServiceModal";
import FinishServiceModal from "./FinishServiceModal";
import ReferenceServiceModal from "./ReferenceServiceModal";
import SidePopup from "../../components/Common/SidePopUp";
import DetailService from "./DetailService";

const CardServiceV2 = ({ service, infoUser, setSelectedService, typeService, setRequestServiceCancelModal, clickAssignService, onClickAssignService }) => {

  const location = useLocation();
  const navigate = useNavigate();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notesModalOpen, setNotesModalOpen] = useState(false);
  const [isNoteValid, setIsNoteValid] = useState(false);
  const [finishServiceModalOpen, setFinishServiceModalOpen] = useState(false);
  const [referenceServiceModalOpen, setReferenceServiceModalOpen] = useState(false);
  const [detailPopupOpen, setDetailPopupOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleNotesModal = () => setNotesModalOpen(!notesModalOpen);
  const toggleFinishServiceModal = () => setFinishServiceModalOpen(!finishServiceModalOpen);
  const toggleReferenceServiceModal = () => setReferenceServiceModalOpen(!referenceServiceModalOpen);
  const toggleDetailPopup = () => setDetailPopupOpen(!detailPopupOpen);

  const onClickDelete = (service) => {
    setSelectedService(service);
    setRequestServiceCancelModal(true);
  };

  const onClickEdit = (service) => {
    setSelectedService(service);
    navigate(`/services/request/edit/${service.code}`);
  };

  const onClickReassign = (service) => {
    setSelectedService(service);

    const storedServices = JSON.parse(localStorage.getItem("services")) || [];
    const updatedServices = [...storedServices, service];
    localStorage.setItem("services", JSON.stringify(updatedServices));

    navigate(`/services/reassignment/${service.code}`);
  };

  const handleDetailClick = (e) => {
    e.preventDefault();
    localStorage.setItem('typeService', typeService);
    toggleDetailPopup();
  };

  return (
    <Fragment>
      <tr key={service.code}>
        {clickAssignService && (
          <td>
            <Input
              type="checkbox"
              id={`check-${service.code}`}
              className="checksServices"
              name="checksEmployees"
              onClick={(e) => onClickAssignService(service, "one", e)}
            />
          </td>
        )}
        <td>{service.partner_name}</td>
        <td>{service.code}</td>
        {service.status.key !== ServiceStatus.UNASSIGNED && (
          <td>{service.plate}</td>
        )}
        <td className="fs-10">
          <div>
            <strong>{i18n.t("Origin")}:</strong>{" "}
            {service.origin?.status === "DEFINED"
              ? service?.origin?.address?.description
              : ""}
          </div>
          {service.destination?.status === "DEFINED" && service.destination?.address?.description && (
            <>
              <hr style={{ width: "100%", borderTop: "1px solid #EFF2F7", margin: "6px 0" }} />
              <div>
                <strong>{i18n.t("Destination")}:</strong>{" "}
                {service?.destination?.address?.description}
              </div>
            </>
          )}
        </td>
        <td>{service.scheduled_start.date}</td>
        <td>{`${service.scheduled_start.time} ${service.scheduled_start.period}`}</td>
        <td style={{ whiteSpace: "nowrap" }}>
          {service.scheduled_type === ServiceScheduledType.ON_DEMAND
            ? i18n.t("OnDemand")
            : service.scheduled_type === ServiceScheduledType.RESERVED
            ? i18n.t("Reserved")
            : service.scheduled_type}
        </td>
        <td>{service.place || ""}</td>
        {service.status.key === ServiceStatus.ASSIGNED && (
          <td className="text-center">
            <i
              id={`driverStatusIcon-${service.code}`}
              className={`bx bx-home font-size-18 ${
                service.driver_in_pickup_spot
                  ? "text-success"
                  : service.driver_on_way
                  ? "text-warning"
                  : "text-danger"
              }`}
            />
            <UncontrolledTooltip placement="top" target={`driverStatusIcon-${service.code}`}>
              {service.driver_in_pickup_spot
                ? i18n.t("AtDomicile")
                : service.driver_on_way
                ? i18n.t("OnTheWay")
                : i18n.t("Awaiting")}
            </UncontrolledTooltip>
          </td>
        )}
        <td className="d-flex">
          <button
            onClick={handleDetailClick}
            className="btn btn-soft-primary waves-effect waves-light btn btn-secondary mx-1 align-content-center"
          >
            <i className="fas fa-eye" />
          </button>
          {service.status.key !== ServiceStatus.ASSIGNED && (
            <button
              className="btn btn-edit waves-effect waves-light mx-1 edit-button"
              onClick={() => onClickEdit(service)}
              id={`edittooltip-${service.code}`}
              disabled={[ServiceStatus.STARTED, ServiceStatus.FINISHED, ServiceStatus.DELETED].includes(service.status.key)}
            >
            <i className="mdi mdi-pencil font-size-18 edit-icon"></i>
              <UncontrolledTooltip placement="top" target={`edittooltip-${service.code}`}>
                {i18n.t("Edit")}
              </UncontrolledTooltip>
            </button>                
          )}
          {[ServiceStatus.ASSIGNED].includes(service.status.key) &&
            infoUser.permissions.includes(Permissions.UNASSIGN_SERVICES) && (
              <button
                className="btn btn-edit waves-effect waves-light mx-1 edit-button"
                onClick={() => onClickReassign(service)}
                id={`edittooltip-${service.code}`}
              >
              <i className="mdi mdi-pencil font-size-18 edit-icon" />
                <UncontrolledTooltip placement="top" target={`edittooltip-${service.code}`}>
                  {i18n.t("Edit")}
                </UncontrolledTooltip>
              </button>                
            )
          }
            <button
              className="btn btn-deleted-request waves-effect waves-light mx-1"
              onClick={() => onClickDelete(service)}
              id={`deletetooltip-${service.code}`}
              disabled={![ServiceStatus.UNASSIGNED, ServiceStatus.ASSIGNED, ServiceStatus.REJECTED].includes(service.status.key)}
            >
              <i className="mdi mdi-delete font-size-18 deleted-icon" />
              <UncontrolledTooltip placement="top" target={`deletetooltip-${service.code}`}>
                {i18n.t("Cancel")}
              </UncontrolledTooltip>
            </button>
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} direction="left">
              <DropdownToggle
                className="btn btn-more-actions waves-effect waves-light btn btn-secondary mx-1"
                tag="button"
                id={`moreactionstooltip-${service.code}`}
                disabled={[ServiceStatus.STARTED, ServiceStatus.FINISHED].includes(service.status.key)}
              >
                <i className="mdi mdi-dots-vertical font-size-18 more-actions-icon" />
              </DropdownToggle>
              <UncontrolledTooltip placement="top" target={`moreactionstooltip-${service.code}`}>
                {i18n.t("MoreActions")}
              </UncontrolledTooltip>
              <DropdownMenu>
                <DropdownItem onClick={toggleNotesModal}>
                  {i18n.t("Notes")}
                </DropdownItem>
                {service.status.key === ServiceStatus.ASSIGNED && infoUser.is_staff && (
                  <DropdownItem onClick={toggleFinishServiceModal}>
                    {i18n.t("EndWithoutPassenger")}
                  </DropdownItem>
                )}
                {service.status.key === ServiceStatus.ASSIGNED && infoUser.is_staff && (
                  <DropdownItem onClick={toggleReferenceServiceModal}>
                    {i18n.t("EditReferenceNote")}
                  </DropdownItem>
                )}
                {service.status.key === ServiceStatus.UNASSIGNED && (
                  <DropdownItem
                    onClick={() => {
                      sessionStorage.setItem("rescheduleServiceCode", service.code);
                      navigate("/services/request/reschedule");
                    }}
                  >
                    {i18n.t("Reschedule")}
                  </DropdownItem>
                )}
                {service.status.key === ServiceStatus.UNASSIGNED && (
                  <DropdownItem
                    onClick={() => {
                      localStorage.removeItem("services");
                      localStorage.setItem("services", JSON.stringify([service]));
                      localStorage.setItem("notify", "false");
                      localStorage.setItem("headerText", i18n.t("AssignAService"));
                      localStorage.setItem("bodyText", i18n.t("ServiceAssignmentStarted"));
                      navigate("/services/assignment/create");
                    }}
                  >
                    {i18n.t("AssignAService")}
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
        </td>
      </tr>
      <NotesServiceModal
        isOpen={notesModalOpen}
        toggle={toggleNotesModal}
        selectedService={service}
        setIsNoteValid={setIsNoteValid}
      />
      <FinishServiceModal
        isOpen={finishServiceModalOpen}
        toggle={toggleFinishServiceModal}
        selectedService={service}
      />
      <ReferenceServiceModal
        isOpen={referenceServiceModalOpen}
        toggle={toggleReferenceServiceModal}
        selectedService={service}
      />
      <SidePopup isOpen={detailPopupOpen} toggle={toggleDetailPopup}>
        <DetailService 
          serviceCode={service.code}
          serviceStatus={service.status?.key}
          isPopup={true}
          onClose={toggleDetailPopup}
        />
      </SidePopup>
    </Fragment>
  );
};

CardServiceV2.propTypes = {
  service: PropTypes.object.isRequired,
};

export default CardServiceV2;
